module.exports = __webpack_public_path__ + "img/Avatar-66.bd75a3e3.svg";